import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { usersKeys } from '../api/users.keys'
import { usersApi } from '../api/users.api'
import { User } from '../types'

/**
 * Hook to fetch all users
 */
export function useUsers(isActive?: boolean | undefined) {
  return useQuery<User[], Error>({
    queryKey: usersKeys.allUsers(isActive),
    queryFn: () => usersApi.getAllUsers(isActive ?? false),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

/**
 * Hook to toggle user active/inactive
 */
export function useToggleUserActive() {
  const queryClient = useQueryClient()

  return useMutation<void, Error, string | number>({
    mutationFn: (userId: string | number) => usersApi.toggleActiveUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: usersKeys.allUsers(true) })
      queryClient.invalidateQueries({ queryKey: usersKeys.allUsers(false) })
    },
  })
}


